import React from 'react';

interface AdditionalStatisticsProps {
  reportCard: any;
  formatTime: (seconds: number) => string;
}

const AdditionalStatistics: React.FC<AdditionalStatisticsProps> = ({ reportCard, formatTime }) => {
  if (!reportCard) return null;

  return (
    <div className="row g-4 mb-4">
      <div className="col-md-12">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
          <div className="card-header bg-transparent border-0 pt-4">
            <h5 className="card-title fw-bold mb-0">
              <i className="fas fa-chart-bar me-2 text-primary"></i>
              Detailed Statistics
            </h5>
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-3">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-muted mb-1">Avg Time/Quiz</h6>
                  <p className="mb-0 fw-bold">{formatTime(parseInt(reportCard.average_time_per_quiz_seconds))}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-muted mb-1">Avg Time/Question</h6>
                  <p className="mb-0 fw-bold">{parseFloat(reportCard.average_time_per_question_seconds).toFixed(1)}s</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-muted mb-1">Best Quiz</h6>
                  <p className="mb-0 fw-bold text-truncate" title={reportCard.highest_score_quiz_name}>
                    {reportCard.highest_score_quiz_name ? reportCard.highest_score_quiz_name.substring(0, 20) + '...' : 'N/A'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-center p-3 border rounded">
                  <h6 className="text-muted mb-1">Achievement Score</h6>
                  <p className="mb-0 fw-bold">{parseFloat(reportCard.achievement_score).toFixed(1)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalStatistics;
